var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      style: _vm.windowIsLarge
        ? {
            color: _vm.$themeTokens.text,
            backgroundColor: _vm.$themeTokens.surface,
            width: _vm.width,
          }
        : {},
      attrs: {
        role: "region",
        closeButtonIconType: _vm.closeButtonIcon,
        "aria-label": _vm.filterAndSearchLabel$(),
        ariaLabel: _vm.filterAndSearchLabel$(),
      },
      on: {
        closePanel: function ($event) {
          _vm.currentCategory
            ? (_vm.currentCategory = null)
            : _vm.$emit("close")
        },
        shouldFocusFirstEl: function ($event) {
          return _vm.focusFirstEl()
        },
      },
    },
    [
      _vm.windowIsLarge || !_vm.currentCategory
        ? _c("div", { class: _vm.windowIsLarge ? "" : "drawer-panel" }, [
            !_vm.accordion
              ? _c(
                  "div",
                  [
                    _vm.searchLoading
                      ? _c("KLinearLoader", { staticClass: "linear-loader" })
                      : _vm._e(),
                    _c("h2", { staticClass: "title" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$tr("keywords")) + "\n      "
                      ),
                    ]),
                    _c("SearchBox", {
                      key: "channel-search",
                      ref: "searchBox",
                      attrs: {
                        placeholder: _vm.coreString("findSomethingToLearn"),
                        disabled: _vm.searchLoading,
                        value: _vm.value.keywords || "",
                      },
                      on: {
                        change: (val) =>
                          _vm.$emit("input", { ..._vm.value, keywords: val }),
                      },
                    }),
                    Object.keys(_vm.availableLibraryCategories).length
                      ? _c(
                          "div",
                          [
                            _c("h2", { staticClass: "section title" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$tr("categories")) +
                                  "\n        "
                              ),
                            ]),
                            _vm._l(
                              _vm.availableLibraryCategories,
                              function (category, key) {
                                return _c(
                                  "div",
                                  {
                                    key: key,
                                    staticClass: "category-list-item",
                                    attrs: { span: "4" },
                                  },
                                  [
                                    _c("KButton", {
                                      attrs: {
                                        text: _vm.coreString(category.value),
                                        appearance: "flat-button",
                                        appearanceOverrides:
                                          _vm.isCategoryActive(category.value)
                                            ? {
                                                ..._vm.categoryListItemStyles,
                                                ..._vm.categoryListItemActiveStyles,
                                              }
                                            : _vm.categoryListItemStyles,
                                        disabled:
                                          _vm.searchLoading ||
                                          (_vm.availableRootCategories &&
                                            !_vm.availableRootCategories[
                                              category.value
                                            ] &&
                                            !_vm.isCategoryActive(
                                              category.value
                                            )),
                                        iconAfter: _vm.hasNestedCategories(key)
                                          ? "chevronRight"
                                          : null,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleCategory(key)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "category-list-item",
                                attrs: { span: "4" },
                              },
                              [
                                _c("KButton", {
                                  attrs: {
                                    text: _vm.coreString("uncategorized"),
                                    appearance: "flat-button",
                                    disabled: _vm.searchLoading,
                                    appearanceOverrides: _vm.isCategoryActive(
                                      "no_categories"
                                    )
                                      ? {
                                          ..._vm.categoryListItemStyles,
                                          ..._vm.categoryListItemActiveStyles,
                                        }
                                      : _vm.categoryListItemStyles,
                                  },
                                  on: { click: _vm.noCategories },
                                }),
                              ],
                              1
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.showActivities
                      ? _c("ActivityButtonsGroup", {
                          staticClass: "section",
                          on: { input: _vm.handleActivity },
                        })
                      : _vm._e(),
                    _c("SelectGroup", {
                      staticClass: "section",
                      attrs: { showChannels: _vm.showChannels },
                      model: {
                        value: _vm.inputValue,
                        callback: function ($$v) {
                          _vm.inputValue = $$v
                        },
                        expression: "inputValue",
                      },
                    }),
                    Object.keys(_vm.availableResourcesNeeded).length
                      ? _c(
                          "div",
                          { staticClass: "section" },
                          [
                            _c("h2", { staticClass: "title" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.coreString("showResources")) +
                                  "\n        "
                              ),
                            ]),
                            _vm._l(
                              _vm.availableResourcesNeeded,
                              function (val, activity) {
                                return _c(
                                  "div",
                                  {
                                    key: activity,
                                    attrs: { span: "4", alignment: "center" },
                                  },
                                  [
                                    _c("KCheckbox", {
                                      attrs: {
                                        checked: _vm.value.learner_needs[val],
                                        label: _vm.coreString(activity),
                                        disabled:
                                          _vm.searchLoading ||
                                          (_vm.availableNeeds &&
                                            !_vm.availableNeeds[val]),
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.handleNeed(val)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.accordion && !_vm.currentCategory
              ? _c(
                  "div",
                  [
                    _c("h2", { staticClass: "title" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.title || _vm.$tr("keywords")) +
                          "\n      "
                      ),
                    ]),
                    _c("SearchBox", {
                      key: "channel-search",
                      ref: "searchBox",
                      staticStyle: { "margin-bottom": "1em" },
                      attrs: {
                        disabled: _vm.searchLoading,
                        placeholder: _vm.$tr("searchByKeyword"),
                        value: _vm.value.keywords || "",
                      },
                      on: {
                        change: (val) =>
                          _vm.$emit("input", { ..._vm.value, keywords: val }),
                      },
                    }),
                    _vm.showActivities
                      ? _c("ActivityButtonsGroup", {
                          staticClass: "section",
                          on: { input: _vm.handleActivity },
                        })
                      : _vm._e(),
                    _c("AccordionSelectGroup", {
                      staticStyle: { "margin-top": "1em" },
                      attrs: {
                        showChannels: _vm.showChannels,
                        activeCategories: _vm.activeCategories,
                        handleCategory: _vm.handleCategory,
                      },
                      model: {
                        value: _vm.inputValue,
                        callback: function ($$v) {
                          _vm.inputValue = $$v
                        },
                        expression: "inputValue",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.currentCategory
        ? _c(
            _vm.accordion || !_vm.windowIsLarge ? "div" : "KModal",
            {
              tag: "component",
              attrs: {
                appendToOverlay: "",
                title: _vm.$tr("chooseACategory"),
                cancelText: _vm.coreString("closeAction"),
                size: "large",
              },
              on: {
                cancel: function ($event) {
                  _vm.currentCategory = null
                },
              },
            },
            [
              _c("CategorySearchModal", {
                ref: "searchModal",
                class: _vm.windowIsLarge ? "" : "drawer-panel",
                attrs: { selectedCategory: _vm.currentCategory },
                on: { input: _vm.selectCategory },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }